
import React from 'react';
import { EmbeddedPost } from 'react-facebook';

export default function OzFacebookPost({ cmpProps, style }) {
    let { href } = cmpProps;
    return <EmbeddedPost style={style} href={href} />
}